exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".icon__HVi7_{margin-right:15px}", ""]);

// exports
exports.locals = {
	"icon": "icon__HVi7_"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMaps":true,"modules":true,"importLoaders":1,"camelCase":true,"minimize":true,"localIdentName":"[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/components/Navigation/components/NavigationLink/styles.css
// module id = 240
// module chunks = 77